var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "main-content"
  }, [_c('PageHeader', [_c('PageHeaderTitleContent', [_c('TitleTextContent', {
    attrs: {
      "titleText": 'Products & Services',
      "subTitleText": 'The Project Spectrum Tools Review section offers an independent, third-party assessment of various cybersecurity-related platforms prepared by our cyber advisors. These reviews are vendor-agnostic and should not be interpreted as an endorsement for any product or platform. If you have questions or concerns, please contact our <a href=mailto\:support\@projectspectrum\.io>Support Team</a> for assistance.'
    }
  })], 1)], 1), _c('section', {
    staticClass: "section p-0 mt-5"
  }, [_c('div', {
    staticClass: "container-fluid px-xs-1 px-md-5",
    attrs: {
      "id": "top-container"
    }
  }, [_c('b-row', [_c('b-col', {
    staticClass: "p-0",
    attrs: {
      "lg": "4",
      "xl": "3"
    }
  }), _c('b-col', {
    staticClass: "pb-0 pb-1",
    attrs: {
      "lg": "8",
      "xl": "9",
      "sm": "12",
      "xs": "12"
    }
  }, [_c('div', {
    staticClass: "product-title pl-2"
  }, [_vm._v("Products & Services")])])], 1), _c('b-row', {
    staticClass: "m-0"
  }, [_c('b-col', {
    attrs: {
      "lg": "4",
      "xl": "3",
      "sm": "12",
      "xs": "12"
    }
  }, [_c('div', {
    staticClass: "p-3 px-4 my-2 mb-4 search-and-filter"
  }, [_c('b-form-group', {
    staticClass: "search-and-filter-title"
  }, [_c('label', [_vm._v("Search by Name:")]), _c('b-form-input', {
    attrs: {
      "placeholder": "Type and enter to search...",
      "trim": ""
    },
    model: {
      value: _vm.searchQuery,
      callback: function ($$v) {
        _vm.searchQuery = $$v;
      },
      expression: "searchQuery"
    }
  })], 1), _c('b-form-group', {
    staticClass: "search-and-filter-title"
  }, [_c('label', [_vm._v("Categories:")]), _c('b-form-select', {
    attrs: {
      "options": _vm.optionsCategories
    },
    model: {
      value: _vm.searchCategory,
      callback: function ($$v) {
        _vm.searchCategory = $$v;
      },
      expression: "searchCategory"
    }
  })], 1), _vm.compareArray.length > 0 ? _c('div', {
    staticClass: "w-100"
  }, [_c('b-form-group', {
    staticClass: "search-and-filter-title"
  }, [_c('label', [_vm._v(_vm._s(`Products & Services Matches: (${_vm.compareArray.length})`))]), _c('ul', {
    staticClass: "m-0"
  }, _vm._l(_vm.selectedItems, function (item) {
    return _c('li', {
      key: item.id,
      staticClass: "selected-company-item mb-2"
    }, [_c('v-row', [_c('v-col', {
      staticClass: "pr-0 pb-0",
      attrs: {
        "cols": "2"
      }
    }, [_c('div', {
      staticClass: "remove-selected-item",
      on: {
        "click": function ($event) {
          return _vm.moreButtonSelection(item.id);
        }
      }
    }, [_vm._v("X")])]), _c('v-col', {
      staticClass: "pl-0 pb-0",
      attrs: {
        "cols": "10"
      }
    }, [_c('div', [_vm._v(_vm._s(item.toolCreatedBy))])])], 1)], 1);
  }), 0)]), _c('b-form-group', {
    staticClass: "d-flex justify-content-center"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'tool-compare',
        query: {
          ids: _vm.compareArray
        }
      }
    }
  }, [_c('b-button', {
    key: "",
    staticClass: "btn-compare-selected",
    attrs: {
      "id": "input-1",
      "size": "sm",
      "disabled": _vm.compareArray.length < 2
    }
  }, [_vm._v("Compare Products & Services")])], 1)], 1), _c('b-form-group', {
    staticClass: "d-flex justify-content-center"
  }, [_c('b-button', {
    key: "",
    staticClass: "btn-compare-selected",
    attrs: {
      "id": "input-2",
      "size": "sm"
    },
    on: {
      "click": _vm.deselectAllCompareCheckboxes
    }
  }, [_vm._v("Clear All")])], 1)], 1) : _vm._e()], 1)]), _c('b-col', {
    attrs: {
      "lg": "8",
      "xl": "9",
      "sm": "12",
      "xs": "12"
    }
  }, [_c('div', [_c('h5', {
    staticClass: "text-center text-md-left text-lg-left text-xl-left"
  }, [_vm._v("Products & Services Listing")]), _c('p', {
    staticClass: "paragraph-statement text-center text-md-left text-lg-left text-xl-left my-3"
  }, [_vm._v("Select up to 6 tools to compare, matches can be found on the left hand side filter")])]), _vm.itemsFromSearchQuery.length > 0 || _vm.isLoading ? _c('b-table', {
    staticClass: "mt-3",
    attrs: {
      "id": "tool-table",
      "fields": _vm.fields,
      "items": _vm.itemsFromSearchQuery,
      "busy": _vm.isLoading,
      "thead-class": "table-header",
      "tbody-class": "table-body",
      "responsive": "",
      "sort-icon-left": "",
      "outlined": "",
      "hover": "",
      "sticky-header": ""
    },
    scopedSlots: _vm._u([{
      key: "table-busy",
      fn: function () {
        return [_c('div', {
          staticClass: "text-center text-secondary my-2"
        }, [_c('b-spinner', {
          staticClass: "align-middle"
        }), _c('strong', {
          staticClass: "pl-2"
        }, [_vm._v("Loading...")])], 1)];
      },
      proxy: true
    }, {
      key: "cell(compare)",
      fn: function (data) {
        return [_c('b-form-checkbox', {
          attrs: {
            "size": "lg",
            "checked": _vm.compareArray.includes(data.item.id),
            "value": true,
            "unchecked-value": false
          },
          on: {
            "change": function ($event) {
              return _vm.moreButtonSelection(data.item.id);
            }
          },
          model: {
            value: _vm.form.checkbox[data.item.id],
            callback: function ($$v) {
              _vm.$set(_vm.form.checkbox, data.item.id, $$v);
            },
            expression: "form.checkbox[data.item.id]"
          }
        })];
      }
    }, {
      key: "cell(toolCreatedBy)",
      fn: function (data) {
        return [_c('div', {
          staticClass: "image-and-tool d-flex"
        }, [_c('div', [_c('b-img', {
          staticClass: "tool-icon",
          attrs: {
            "src": data.item.mainImage,
            "rounded": "",
            "alt": "Rounded image"
          }
        })], 1), _c('p', {
          staticClass: "clipped-text m-0"
        }, [_vm._v(_vm._s(data.item.toolCreatedBy))])])];
      }
    }, {
      key: "cell(more)",
      fn: function (data) {
        return [_c('div', {
          staticClass: "image-and-tool d-flex"
        }, [_c('router-link', {
          attrs: {
            "to": {
              name: 'tool-details',
              query: {
                id: data.item.id
              }
            }
          }
        }, [_c('b-button', {
          staticClass: "btn-more",
          attrs: {
            "size": "lg"
          }
        }, [_vm._v("Read More")])], 1)], 1)];
      }
    }], null, false, 3896017787)
  }) : _c('div', {
    staticClass: "empty-items w-100 d-flex flex-row justify-content-center align-items-center text-center"
  }, [_c('span', [_vm._v("There are no Products available for the search query.")])])], 1)], 1)], 1)]), _c('ModalWidget', {
    attrs: {
      "id": "modal-product-issues",
      "title": "Selected Matches Limit Reached",
      "centered": "",
      "hideFooter": ""
    }
  }, [_c('p', {
    staticClass: "modal-paragraph text-center px-5",
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_vm._v(" User Cannot select more than 6 product matches ")]), _c('v-row', {
    attrs: {
      "slot": "row-buttons"
    },
    slot: "row-buttons"
  }, [_c('v-col', {
    staticClass: "d-flex flex-row justify-content-lg-start justify-content-xl-start justify-content-center",
    attrs: {
      "lg": "6",
      "xl": "6",
      "cols": "12"
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'tool-compare',
        query: {
          ids: _vm.compareArray
        }
      }
    }
  }, [_c('b-button', {
    key: "",
    staticClass: "btn-compare-selected",
    attrs: {
      "id": "input-3",
      "size": "sm"
    }
  }, [_vm._v("Compare All ")])], 1)], 1), _c('v-col', {
    staticClass: "d-flex flex-row justify-content-lg-end justify-content-xl-end justify-content-center",
    attrs: {
      "lg": "6",
      "xl": "6",
      "cols": "12"
    }
  }, [_c('b-button', {
    key: "",
    staticClass: "btn-compare-selected",
    attrs: {
      "id": "input-3",
      "size": "sm"
    },
    on: {
      "click": _vm.deselectAllCompareCheckboxes
    }
  }, [_vm._v("Deselect All ")])], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }